export const CAKE_BNB_LP_MAINNET = '0xC0D717C3849B09D58A26465846D5e1972f64A7d5'
